<template>
  <div class="wrapper">
    <div class="top-bar">
      <div class="top-bar-left" @click="back()">
        <i class="el-icon-back"></i>
        {{ isEdit ? "退出编辑" : "新建 - 教研会议" }}
      </div>
      <div class="top-bar-right">
        <el-button v-if="!isEdit" type="primary" @click="checkAndSave()"
          >发布活动</el-button
        >
        <el-button v-if="isEdit" type="primary" @click="checkAndSave()"
          >更新发布</el-button
        >
      </div>
    </div>
    <div class="content">
      <div
        style="
          background-color: white;
          padding: 16px;
          width: 60vw;
          margin: 16px auto;
        ">
        <el-form
          ref="researchForm"
          :model="research"
          :rules="rules"
          label-width="110px"
        >
          <el-form-item label="活动名称" prop="name">
            <el-input
              v-model="research.name"
              maxlength="60"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择年级" prop="grade">
                <el-select
                  v-model="research.grade"
                  placeholder="请选择年级"
                  style="width: 100%"
                  @change="selectGrade"
                >
                  <el-option
                    v-for="item in gradeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择学科" prop="subject_code">
                <el-select
                  v-model="research.subject_code"
                  placeholder="请选择学科"
                  style="width: 100%"
                  @change="selectSubject"
                >
                  <el-option
                    v-for="item in subjectList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="选择讲师">
            <el-cascader
              :options="subjectTeacherList"
              style="width: 100%"
              @change="changeLecturer"
              v-model="research.lecturer_uuid_array"
            ></el-cascader>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择日期" prop="start_date_str" required>
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                  align="center"
                  v-model="research.start_date_str"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="选择时间" prop="start_end_time_array">
                <el-time-picker
                is-range
                  start-placeholder="选择开始时间"
                  end-placeholder="选择结束时间"
                  style="width: 100%"
                  align="center"
                  format="HH:mm"
                  v-model="research.start_end_time_array"
                  value-format="HH:mm"
                ></el-time-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="会议资料">
            <el-card class="box-card">
              <div class="blue-underline" @click="showUploadDialog = true">
                添加会议资料
              </div>
              <div class="file-list-container">
                <div
                  v-for="(fileItem, fileIndex) in fileList"
                  :key="fileItem.id"
                  class="file-list-item"
                >
                  <img
                    v-if="isImage(fileItem.ext)"
                    src="../../assets/images/course_2.0/图片.png"
                    alt=""
                  />
                  <img
                    v-if="isPDF(fileItem.ext)"
                    src="../../assets/images/course_2.0/pdf.png"
                    alt=""
                  />
                  <img
                    v-if="isPPT(fileItem.ext)"
                    src="../../assets/images/course_2.0/PPT.png"
                    alt=""
                  />
                  <img
                    v-if="isWord(fileItem.ext)"
                    src="../../assets/images/course_2.0/word.png"
                    alt=""
                  />
                  <img
                    v-if="isExcel(fileItem.ext)"
                    src="../../assets/images/course_2.0/excel.png"
                    alt=""
                  />

                  <img
                    v-if="isAudio(fileItem.ext)"
                    src="../../assets/images/course_2.0/音频.png"
                    alt=""
                  />

                  <img
                    v-if="isVideo(fileItem.ext)"
                    src="../../assets/images/course_2.0/视频.png"
                    alt=""
                  />
                  <div class="file-list-item-name">{{ fileItem.name }}</div>
                  <div
                    class="file-list-item-remove"
                    @click="removeFile(fileIndex)"
                  >
                    删除
                  </div>
                </div>
              </div>
            </el-card>
          </el-form-item>

        
        </el-form>
      </div>
    </div>

    <el-dialog
      title="上传文件"
      :visible.sync="showUploadDialog"
      width="50%"
      :close-on-click-modal="false"
    >
      <div class="add_material_contnet">
        <div>
          <uploader
            :options="optionsUpload"
            class="uploader-example"
            @file-progress="onFileProgress"
            @file-added="onFileAdded"
            @file-success="onFileSuccess"
            ref="uploader"
          >
            <uploader-unsupport></uploader-unsupport>
            <uploader-drop>
              <uploader-btn :attrs="optionsUpload.attrs">选择文件</uploader-btn>
            </uploader-drop>
            <uploader-list>
              <ul class="file-list" slot-scope="props">
                <li v-for="file in props.fileList" :key="file.id">
                  <uploader-file
                    v-if="!file.completed"
                    :class="'file_' + file.id"
                    ref="files"
                    :file="file"
                    :list="true"
                  ></uploader-file>
                </li>
              </ul>
            </uploader-list>
            <div style="opacity: 0">列表</div>
          </uploader>

          <!--  -->
          <div style="display: flex; flex-wrap: wrap">
            <div
              class="add_course_info_content_box_content_item"
              @click="previewFile(item_f)"
              v-for="(item_f, index_f) in uploadFileList"
              :key="index_f + 'f'"
            >
              <div class="add_course_info_content_box_content_item_img">
                <div
                  class="add_course_info_content_box_content_item_del"
                  @click.stop="
                    $confirm('确认删除？')
                      .then((_) => {
                        uploadFileList.splice(index_f, 1);
                      })
                      .catch((_) => {})
                  "
                >
                  <img
                    src="../../assets/images/course_2.0/del_course_item.png"
                    alt=""
                  />
                </div>
                <img
                  v-if="isImage(item_f.type)"
                  src="../../assets/images/course_2.0/图片.png"
                  class="add_course_info_content_box_content_item_img_homework"
                  alt=""
                />
                <img
                  v-else-if="isPDF(item_f.type)"
                  src="../../assets/images/course_2.0/pdf.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-else-if="isPPT(item_f.type)"
                  src="../../assets/images/course_2.0/PPT.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-else-if="isWord(item_f.type)"
                  src="../../assets/images/course_2.0/word.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-else-if="isExcel(item_f.type)"
                  src="../../assets/images/course_2.0/excel.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />

                <img
                  v-else-if="isAudio(item_f.type)"
                  src="../../assets/images/course_2.0/音频.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />

                <img
                  v-else-if="isVideo(item_f.type)"
                  src="../../assets/images/course_2.0/视频.png"
                  class="add_course_info_content_box_content_item_img_homework"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/images/course_choose/资料包.png"
                  class="add_course_info_content_box_content_item_img_homework"
                  alt=""
                />
              </div>
              <div class="add_course_info_content_box_content_item_txt">
                {{ item_f.name || item_f.title || "" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeUploadDialog">取 消</el-button>
        <el-button type="primary" @click="saveUploadFile">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="'预览：' + (prew_content.name || prew_content.title)"
      :visible.sync="showPreviewDialog"
      width="50%"
      custom-class="sign_course_edit_rich_guide_dia_prew"
    >
      <previewData
        v-if="showPreviewDialog"
        :prew_type="prew_type"
        :prew_content="prew_content"
      ></previewData>
    </el-dialog>
  </div>
</template>

<script>
import bus from "../../plugins/Bus";
import previewData from "../../components/common_module/preview_data.vue";
export default {
  components: { previewData },
  data() {
    return {
      isEdit: false,
      isFromPreview: false,
      expertProps: { multiple: true },
      research: {
        uuid: "",
        name: "",
        grade: "",
        subject_code: "",
        lecturer_uuid_array: [],
        lecturer_uuid: "",
        lecturer_name: "",
        start_time: "",
        start_date_str: "",
        start_end_time_array: null,
        
      },
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        grade: [{ required: true, message: "请选择年级", trigger: "change" }],
        subject_code: [
          { required: true, message: "请选择学科", trigger: "change" },
        ],
        lecturer_uuid_array: [
          {
            validator: (rule, value, callback) => {
              if (
                this.research.lecturer_uuid_array.length == 0 ||
                !this.research.lecturer_uuid_array[1]
              ) {
                callback(new Error("请设置讲师"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        start_date_str: [
          {
            validator: (rule, value, callback) => {
              if (
                this.research.start_date_str == null ||
                this.research.start_date_str == ""
              ) {
                callback(new Error("请选择开始日期"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        start_end_time_array: [
          {
            validator: (rule, value, callback) => {
              if (
                this.research.start_end_time_array == null ||
                this.research.start_end_time_array.length != 2
              ) {
                callback(new Error("请选择开始时间"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ]
      },
      userInfo: "",
      fileList: [],
      gradeList:[],
      allSubjectList: [],
      subjectList: [],
      teacherList: [],
      allSubjectTeacherList: [],
      subjectTeacherList: [],
      showUploadDialog: false,
      uploadFileList: [],
      optionsUpload: {
        target: "",
        testChunks: false,
        allowDuplicateUploads: true,
        attrs: {
          accept:
            ".pptx,.doc,.DOC,.docx,.DOCX,.xls,.xlsx,.pdf,.mp3,.mp4,.flv,.mov,.mpg,image/*",
        },
        headers:{
          token: sessionStorage.token,
          key: sessionStorage.keyValue
        },
        chunkSize: "1024000",
      },
      showPreviewDialog: false,
      prew_content: "",
      prew_type: "",
    };
  },

  beforeCreate() {},
  created() {
    if (this.$route.params.uuid && this.$route.params.uuid != '0') {
      this.research.uuid = this.$route.params.uuid;
    }

    if (this.research.uuid) {
      this.isEdit = true;
    }

    if (this.$route.query.flag) {
      this.isFromPreview = true;
    }
    this.optionsUpload.target =
      sessionStorage.url + "/proxy2/cloud/upload/zoneupload?convert_now=1";
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.userInfo);
    //获取
    this.getGradeList();
    //获取教研活动
    if (this.research.uuid) {
      this.getActivity();
    }

    if (this.isFromPreview) {
      let allData = JSON.parse(sessionStorage.newTeachActivity);
      this.research = allData.research;
      this.fileList = allData.fileList;
    }
  },
  methods: {
    // 获取年级
    getGradeList() {
      this.axios.get("/teacher/subject/getgrads").then((res) => {
        if (res.data.code == 1) {
          this.gradeList = res.data.data;
          this.getSubjectAndTeacherList();
        }
      });
    },
    // 获取学科列表
    getSubjectAndTeacherList() {
      this.axios
        .get("/teacher/teacher/getTeacherAndSubjectList", {
          params: { schoolcode: this.userInfo.school_code },
        })
        .then((res) => {
          this.allSubjectList = res.data.data.subjectList;
          this.subjectList = res.data.data.subjectList;
          this.teacherList = res.data.data.teacherList;
          this.subjectTeacherList = this.subjectList.map((x) => {
            return {
              value: x.code,
              label: x.name,
              grade_id: x.grade_id,
              children: this.teacherList
                .filter((y) => y.subject_code == x.code)
                .map((z) => {
                  return {
                    value: z.uuid,
                    label: z.name,
                    children: null,
                  };
                }),
            };
          });

          this.allSubjectTeacherList = this.subjectTeacherList;
        });
    },
    getActivity() {
      this.axios
        .get("/teacher/research/getTeachActivity", {
          params: { uuid: this.research.uuid },
        })
        .then((res) => {
          this.fileList = res.data.data.fileList;
          let research = res.data.data.teachActivity;
          research.fileList = res.data.data.fileList;
          research.grade = parseInt(research.grade);
          research.lecturer_uuid_array = [
            research.lecturer_subject_code,
            research.lecturer_uuid,
          ];
          let startTime = new Date(research.start_time);
          let endTime = new Date(research.end_time);
          research.start_date_str = this.formatDate(startTime, "yyyy-MM-dd");
          research.start_end_time_array = [this.formatDate(startTime, "HH:mm"),this.formatDate(endTime, "HH:mm")] ;
          this.research = research;
        });
    },
    //选中年级
    selectGrade() {
      this.research.subject = "";
      if (this.research.grade) {
        let gradeId = parseInt(this.research.grade / 10) * 10;
        this.subjectList = this.allSubjectList.filter(
          (x) => x.grade_id == gradeId
        );

        if (this.research.subject_code) {
          if (
            this.subjectList.findIndex(
              (x) => x.code == this.research.subject_code
            ) == -1
          ) {
            this.research.subject_code = "";
            this.research.lecturer_uuid_array = [];

            this.subjectTeacherList = this.allSubjectTeacherList.filter(
              (x) => x.grade_id == gradeId
            );
          }
        }
      }
    },
    selectSubject() {
      if (this.research.subject_code) {
        this.research.lecturer_uuid_array = [];
        this.subjectTeacherList = this.allSubjectTeacherList.filter(
          (x) => x.value == this.research.subject_code
        );
      }
    },
    changeLecturer() {
      this.$refs["researchForm"].clearValidate(["lecturer_uuid_array"]);
    },
    
    //上传方法
    closeUploadDialog() {
      this.showUploadDialog = false;
      this.uploadFileList.splice(0, this.uploadFileList.length);
    },
    saveUploadFile() {
      if (this.uploadFileList.length == 0) {
        return;
      }
      this.$refs["researchForm"].clearValidate(["file"]);
      var ticks = new Date().getTime();
      this.fileList = this.fileList.concat(
        this.uploadFileList.map((x) => {
          return {
            id: ticks++,
            name: x.name,
            url: x.url,
            ext: x.type,
            type: x.type,
          };
        })
      );
      this.closeUploadDialog();
    },
    removeFile(fileIndex) {
      this.$confirm("确认删除文件吗？")
        .then((_) => {
          this.fileList.splice(fileIndex, 1);
        })
        .catch((_) => {});
    },
    // 上传回调
    onFileProgress(rootFile, file, chunk) {
      if (Math.floor((chunk.endByte / file.size) * 100) > this.ispercentage) {
        this.ispercentage = Math.floor((chunk.endByte / file.size) * 100);
        //  console.log(this.ispercentage)
      }
    },
    onFileAdded(file) {
      this.ispercentage = 0;
      if (
        (file.fileType.indexOf("presentation") != -1 ||
          file.fileType.indexOf("powerpoint") != -1) &&
        file.size / 1024 / 1024 >= 100
      ) {
        file.pause();
        this.$message({
          duration: 3000,
          type: "error",
          message: "ppt大小不能超过100M!",
        });
      }

      this.show_progress = true;
    },
    onFileSuccess(rootFile, file, response, chunk) {
      this.ispercentage = 100;
      this.show_progress = false;

      if (JSON.parse(response).code == 1) {
        try {
          this.upFile_src = JSON.parse(response).data.url;
        } catch (error) {
          this.upFile_src = response;
        }
        this.upFile_type =
          file.name.split(".")[file.name.split(".").length - 1];
        this.ispercentage = 0;
        this.uploadFileList.push({
          name: file.name,
          url: this.upFile_src,
          type: file.name.split(".")[file.name.split(".").length - 1],
          id: file.id,
        });
      } else {
        // file-removed(file)
        this.$message({
          type: "error",
          message: JSON.parse(response).msg,
          duration: 1500,
          showClose: true,
        });
      }
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`).catch((_) => {});
    },
   
    previewFile(item) {
      // return
      if (this.isVideo(item.type)) {
        this.prew_type = "mp4";
      } else if (this.isImage(item.type)) {
        this.prew_type = "img";
      } else if (
        this.isWord(item.type) ||
        this.isPPT(item.type) ||
        this.isExcel(item.type)
      ) {
        this.prew_type = "ppt";
      } else if (this.isAudio(item.type)) {
        this.prew_type = "mp3";
      } else if (this.isPDF(item.type)) {
        this.prew_type = "pdf";
      }

      this.prew_content = item;
      this.showPreviewDialog = true;
    },
    formatDate(date, fmt) {
      let ret;
      const opt = {
        "y+": date.getFullYear().toString(), // 年
        "M+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "m+": date.getMinutes().toString(), // 分
        "s+": date.getSeconds().toString(), // 秒
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }

      return fmt;
    },
    isImage(ext) {
      return (
        ["png", "jpg", "jpeg"].findIndex((x) => x == ext.toLowerCase()) != -1
      );
    },
    isWord(ext) {
      return ["doc", "docx"].findIndex((x) => x == ext.toLowerCase()) != -1;
    },
    isExcel(ext) {
      return ["xls", "xlsx"].findIndex((x) => x == ext.toLowerCase()) != -1;
    },
    isPPT(ext) {
      return ["ppt", "pptx"].findIndex((x) => x == ext.toLowerCase()) != -1;
    },
    isPDF(ext) {
      return ["pdf"].findIndex((x) => x == ext.toLowerCase()) != -1;
    },
    isPDF(ext) {
      return ["pdf"].findIndex((x) => x == ext.toLowerCase()) != -1;
    },
    isAudio(ext) {
      return ["mp3"].findIndex((x) => x == ext.toLowerCase()) != -1;
    },
    isVideo(ext) {
      return (
        ["mp4", "avi", "flv", "swf", "mpg", "mov", "wmv"].findIndex(
          (x) => x == ext.toLowerCase()
        ) != -1
      );
    },
    back() {
        this.$router.push("/research/"+this.$route.params.type);
    },
    checkAndSave() {
      this.$refs["researchForm"].validate((isValid, obj) => {
        if (isValid) {
          this.saveResearch();
        }
      });
    },
    saveResearch() {
      let url = "/teacher/research/saveMeetingActivity";
      let formData = new FormData();
      var lecturer = this.teacherList.find(
        (x) => x.uuid == this.research.lecturer_uuid_array[1]
      );

      formData.append("uuid", this.research.uuid);
      formData.append("type", 3);
      formData.append("teacher_uuid", this.userInfo.uuid);
      formData.append("teacher_name", this.userInfo.name);
      formData.append("from", this.userInfo.school.name);
      formData.append("school_code", this.userInfo.school_code);
      formData.append("name", this.research.name);
      formData.append("grade", this.research.grade);
      formData.append("subject_code", this.research.subject_code);
      
      if( this.research.lecturer_uuid_array.length == 2 && this.research.lecturer_uuid_array[0]  && this.research.lecturer_uuid_array[1]){
        let lecturer = this.teacherList.find(
          (x) => x.uuid == this.research.lecturer_uuid_array[1]
        );
        formData.append("lecturer_uuid", this.research.lecturer_uuid_array[1]);
        formData.append("lecturer_name", lecturer.name);
        formData.append("lecturer_subject_code", this.research.lecturer_uuid_array[0]);
      }

      formData.append(
        "start_time",
        this.research.start_date_str + " " + this.research.start_end_time_array[0]
      );
      formData.append("end_time", this.research.start_date_str + " " + this.research.start_end_time_array[1]);
      formData.append("fileJson", JSON.stringify(this.fileList));

      this.axios.post(url, formData).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            message: res.data.msg,
            type: "success",
            duration: 1500,
            showClose: true,
          });

          if (res.data.code == 1) {
            this.back();
          }
        }
      });
    },
  },
};
</script>


<style scoped>
.wrapper {
  margin: 0px auto;
  height: calc(100vh - 142px);
  overflow: hidden;
  width: 75vw;
  padding-top: 10px;
}

.top-bar {
  padding: 8px 16px;
  height: 44px;
  overflow: hidden;
  position: relative;
  background-color: white;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.top-bar-left {
  position: absolute;
  top: 8px;
  line-height: 44px;
  left: 16px;
  cursor: pointer;
}
.top-bar-right {
  position: absolute;
  top: 8px;
  right: 16px;
}

.content {
  height: calc(100vh - 212px);
  border-left: 2px dashed #ddd;
  border-right: 2px dashed #ddd;
  border-bottom: 2px dashed #ddd;
  overflow: auto;
}

.blue-underline {
  text-decoration: underline;
  color: #409eff;
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
}
.box-card {
  position: relative;
}
.box-card .el-form-item {
  margin-bottom: 20px;
}

.comment-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;
  font-size: 16px;
}
.add_material_contnet {
  padding: 0 20px;
}
.add_material_content_head {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  margin: 10px 0;
}
.add_material_content_des {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin: 10px 0;
}
.add_material_content_btn {
  margin: 10px 0;
}
.uploader-drop {
  border: 0 !important;
  background-color: transparent;
  padding: 0;
  margin: 0 0 10px 0;
}
.uploader-btn {
  height: 36px !important;
  background: #ff9b36 !important;
  border-radius: 10px !important;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  border: 0;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.edit_material_item_type_name {
  margin-bottom: 20px;
}
.add_course_info_content_box_content_item_img {
  width: 120px;
  height: 100px;
  background: #ffffff;
  border: 1px solid #ff9b36;
  border-radius: 12px;
  position: relative;
}
.add_course_info_content_box_content_item {
  margin: 0 21px 21px 0;
  cursor: pointer;
  position: relative;
}
.add_course_info_content_box_content_item_img_homework {
  display: block;
  width: 43px;
  height: 35px;
  margin: 32px auto;
}
.add_course_info_content_box_content_item_del {
  width: 13px;
  height: 13px;
  cursor: pointer;
  position: absolute;
  right: -6px;
  top: -6px;
}
.add_course_info_content_box_content_item_del img {
  display: block;
  width: 13px;
  height: 13px;
}
.add_course_info_content_box_content_item_img_ppt {
  display: block;
  width: 42px;
  height: 42px;
  margin: 28px auto;
}
.add_course_info_content_box_content_item_txt {
  width: 120px;
  /* height: 35px; */
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 35px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.file-list-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
  padding-bottom: 8px;
  border-bottom: solid 1px #efefef;
}

.file-list-item img {
  width: 16px;
  height: 16px;
}

.file-list-item-name {
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left: 16px;
  margin-right: 16px;
}

.file-list-item-remove {
  color: #f56c6c;
  cursor: pointer;
}

.mgt16 {
  margin-top: 16px;
}
</style>

